import { createFileRoute } from "@tanstack/react-router";
import { SettingsPage } from "@corpuscomplete/web/modules/body/pages/settings";

export const Route = createFileRoute("/_authenticated/settings")({
  component: SettingsPage,
});
